import { render } from "./AddRepmanModal.vue?vue&type=template&id=d9bd3492&ts=true"
import script from "./AddRepmanModal.vue?vue&type=script&lang=ts"
export * from "./AddRepmanModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__